import type { LeadStatus } from "../types";
import { STATUS_COLOR } from "../constants";
import { useLocale } from "../../../context/LanguageContext";

interface LeadStatusBadgeProps {
  status: LeadStatus;
}

export function LeadStatusBadge({ status }: LeadStatusBadgeProps) {
  const { t } = useLocale();
  const colorClass = STATUS_COLOR[status] ?? "bg-gray-100 text-gray-800";

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${colorClass}`}
    >
      {t(`leads.status.${status}`)}
    </span>
  );
}
